import styled from 'styled-components';

import { breakpoints, colors } from 'theme';

export const AcceptCookiesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: ${colors.white};
  color: ${colors.greyishBrown};
  text-align: center;
  padding: 12px;
  border-top: solid 1px ${colors.silver};
  @media (min-width: ${breakpoints[2]}) {
    height: 56px;
    flex-direction: row;
    border-top: solid 1px ${colors.silver};
  }
`;
